import Vue from 'vue';
let websock = null
let messageCallback = null
let errorCallback = null
let wsUrl = 'ws://127.0.0.1:5005/'
let tryTime = 0


/**
 * 发起websocket连接
 * @param {string} stringData 需要向后台传递的参数数据
 */
function websocketSend(stringData) {
	// 加延迟是为了尽量让ws连接状态变为OPEN   
	setTimeout(() => {
		// 添加状态判断，当为OPEN时，发送消息
		if (websock.readyState === websock.OPEN) { // websock.OPEN = 1 
			// 发给后端的数据需要字符串化
			// 00048|02|101|20191202110456|MSGID0013456|APPID000||1|
			websock.send(stringData)
		}
		if (websock.readyState === websock.CLOSED) { // websock.CLOSED = 3 
			console.log('websock.readyState=3')
			websock=''
			notify('提示', 'ws连接异常，请检查服务是否启动', 'warning')
			errorCallback()
		}
	}, 500)
}
// 关闭ws连接
function websocketclose(e) {
	// e.code === 1000  表示正常关闭。 无论为何目的而创建, 该链接都已成功完成任务。
	// e.code !== 1000  表示非正常关闭。
	if (e && e.code !== 1000) {
		notify('提示', 'ws连接异常，请稍候重试', 'warning')
		errorCallback()
		// // 如果需要设置异常重连则可替换为下面的代码，自行进行测试
		// if (tryTime < 10) {
		//   setTimeout(function() {
		//    websock = null
		//    tryTime++
		//    initWebSocket()
		//    console.log(`第${tryTime}次重连`)
		//  }, 3 * 1000)
		//} else {
		//  Message.error('重连失败！请稍后重试')
		//}
	}
}
// 初始化weosocket
function initWebSocket() {
	if (typeof(WebSocket) === 'undefined') {
		notify('提示', '您的浏览器不支持WebSocket，无法获取数据,建议使用谷歌浏览器', 'warning')
		return false
	}
	websock = new WebSocket(wsUrl)

	websock.onmessage = function(e) {
		websocketonmessage(e)
	}
	websock.onopen = function() {
		websocketOpen()
	}
	websock.onerror = function() {
		Message.error('ws连接异常，请稍候重试')
		errorCallback()
	}
	websock.onclose = function(e) {
		websocketclose(e)
	}
}
// 建立ws连接
function websocketOpen(e) {
	console.log('ws连接成功')
}
// 接收ws后端返回的数据
function websocketonmessage(e) {
	messageCallback(e.data)
}
function notify(title, message, type) {
	Vue.prototype.$notify({
		title,
		message,
		type
	});
}
/**
 * 发起websocket请求函数
 * @param {Object} agentData 传给后台的参数
 * @param {function} successCallback 接收到ws数据，对数据进行处理的回调函数
 * @param {function} errCallback ws连接错误的回调函数
 */
export function sendWebsocket(agentData, successCallback, errCallback) {
	if(websock){
		messageCallback = successCallback
		errorCallback = errCallback
		websocketSend(agentData)
	}else{
		initWebSocket()
		messageCallback = successCallback
		errorCallback = errCallback
		websocketSend(agentData)
	}
	
	
}
/**
 * 关闭websocket函数
 */
export function closeWebsocket() {
	if (websock) {
		websock.close() // 关闭websocket
		websock.onclose() // 关闭websocket
	}
}




// WEBPACK FOOTER //
// ./static/js/function/socket.js